import { render } from "./UiPageHeader.vue?vue&type=template&id=02b1c7e0"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiPageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02b1c7e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02b1c7e0', __exports__)) {
    api.reload('02b1c7e0', __exports__)
  }
  
  module.hot.accept("./UiPageHeader.vue?vue&type=template&id=02b1c7e0", () => {
    api.rerender('02b1c7e0', render)
  })

}


export default __exports__